











































































import FiltreBox from "@/components/app-filtres/components/box.vue";
import AppLayout from "@/components/app-layout.vue";
import AppNews from "@/components/app-news.vue";
import $inoe from "@/config";
import db from "@/db";
import myAccount from "@/features/moncompte/components/myAccount.vue";
import store from "@/store";
import { CLOSE_LOADING, SHOW_LOADING } from "@/store/types";
import { utils } from "@/util";
import { Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    store.dispatch("moncompte/fetchListUsers").then(function () {
      store.dispatch("moncompte/getInfoDossier");
      next();
    });
  },

  data() {
    return {
      userName: $inoe.getUsername(),
      user: {},
      showModalDelete: false,
    };
  },

  components: { AppLayout, myAccount, AppNews, FiltreBox },

  computed: {
    ...mapGetters("moncompte", [
      "getlistUsers",
      "getAuthStatus",
      "getErrorStatus",
      "getNomDossier",
      "getEnvDossier",
      "getAnnonce",
    ]),
  },

  methods: {
    checkUser(event: any) {
      store.dispatch("moncompte/checkUser", event);
    },
    reset() {
      store.dispatch("moncompte/resetCheckUserStatus");
    },
    back() {
      store.dispatch("moncompte/AuthDisconnect");
      store.dispatch("moncompte/SessionLogout");
    },
    refreshConfig() {
      store
        .dispatch("session/reloadConfiguration")
        .then(() => window.location.reload());
    },
 savePointage() {
  store.dispatch("parametres/savePointage")
  .then((json) => {
    const currentTime = utils.getCurrentTimeNow().format("YYYYMMDD");
    const dossierName = this.getNomDossier;
    const userName = this.userName;

    const backupFileName = `backup_MobiAN_${currentTime}_${dossierName}_${userName}.json`;
    const supplementRowsFileName = `backup_MobiANSUP_${currentTime}_${dossierName}_${userName}.json`;

    this.download(json['backup'], backupFileName, "text/x-json");
    this.download(json['supplementRows'], supplementRowsFileName, "text/x-json");
  })
  .catch((error) => {
    console.error("Error saving pointage:", error);
  });
},
  download(content: any, fileName: string, contentType: string) {
      var a = document.createElement("a");
      var file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    },

    deleteMobi() {
      store.dispatch(SHOW_LOADING);
      db.localDB
        .destroy()
        .then(() => {
          $inoe.clearAll();
          (window.top as any).location.replace("/");
        })
        .catch((err: any) => {
          console.error(err);
        })
        .finally(() => {
          store.dispatch(CLOSE_LOADING);
        });
    },
    openTab(params: string) {
      switch (params) {
        case "team": {
          window.open(
            "https://play.google.com/store/apps/details?id=com.teamviewer.quicksupport.market",
            "_blank"
          );
          break;
        }
        case "anyd": {
          window.open(
            "https://play.google.com/store/apps/details?id=com.anydesk.anydeskandroid",
            "_blank"
          );
          break;
        }
        case "playstore": {
          window.open(
            "https://play.google.com/store/search?q=mobian%20aiga&c=apps",
            "_blank"
          );
          break;
        }
        default:
          break;
      }
    },
    getListUsersFromRemote() {
      store.dispatch(SHOW_LOADING);
      store.dispatch("moncompte/fetchListUsersFromRemote").then((rep: any) => {
        store.dispatch(CLOSE_LOADING);
        (window.top as any).location.replace("/");
      });
    },
  },

  created() {
    console.log("$inoe.getCurrentUserName()", $inoe.getUsername());
  },
  watch: {
    getAnnonce(newVal, oldVal) {
      if (oldVal.length === 0 && newVal.length > 1) {
        (this as any).$swreg.showNotification("Annonce Mobi", {
          body: newVal,
          tag: "InoeMobi",
          icon: "./img/icons/android-icon-96x96.png",
        });
      }
    },
  },
});
